import React, { useState } from "react"
import styled from 'styled-components'
import ArrowIcon from '../Icons/ArrowIcon'
import SaleStickyImg from "../../images/sale/sale-sticky.png"
import { Link } from "gatsby"


const StcikyWrapper = styled.div`
    position: fixed;
    bottom: 50px;
    left: 0;
    z-index: 9999;
    display: inline-block;
    cursor: pointer;
    transition: all .5s;
    transform: translateX(-100%);
    width: 200px;
    @media (min-width: 1200px) {
        width: 200px;
    }
    @media (min-width: 1400px) {
        width: 200px;
    }
    &.show{
        transform: translateX(0);
    .toggle{        
      svg{
        transform:scaleX(-1);
      }
    }
  } 
`

const StickyToggleOpener = styled.button`
    background: #000;
    border: 0;
    cursor: pointer;
    display: inline-block;
    position: absolute;
    top: 26px;
    z-index: 1;
    box-sizing: border-box;
    padding: 0;
    transition: all .5s;
    border-radius: 0 100% 100% 0;
    height: 30px;
    width: 30px;
    right: -30px;
    @media (min-width: 992px) {
        height: 40px;
        width: 40px;
        right: -40px;
    }
    @media (min-width: 992px) {
        &:hover{
            background: #291418;
        }
    }
    svg{
        fill:#fff;        
    }
`

const SaleStickyImage = styled(Link)`
    display:flex;
    margin:0;
    outline:none;
    img{
        border-radius:0 6px 0 0;
    }
`

const SaleSticky = ({ location }) => {
    const [showSticky, setShowSticky] = useState(false)   
    const ToggleHelp = () => {
      setShowSticky(!showSticky);
    }
    return (
        <StcikyWrapper location={location} className={showSticky ? '' : 'show'}>
            <StickyToggleOpener type="button" className="toggle" onClick={ToggleHelp}><ArrowIcon /></StickyToggleOpener>
            <SaleStickyImage to="/specials"><img src={SaleStickyImg} alt="Premier Metal Structures" /></SaleStickyImage>
        </StcikyWrapper>
    )
}
export default SaleSticky